// ======== ANT ADMIN TEMPLATE =========

export const TOGGLE_BOXED_LAYOUT = 'TOGGLE_BOXED_LAYOUT';
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_OFFCANVAS_NAV = 'TOGGLE_OFFCANVAS_NAV';
export const TOGGLE_FIXED_HEADER = 'TOGGLE_FIXED_HEADER';
export const CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH';
export const CHANGE_COLOR_OPTION = 'CHANGE_COLOR_OPTION';
export const CHANGE_THEME = 'CHANGE_THEME';


// ========= USER ==========

// Auth

export const AUTHENTICATION = 'AUTHENTICATION';
export const AUTHENTICATION_BY_VALID_SESSION =
  'AUTHENTICATION_BY_VALID_SESSION';

// Logout

export const LOGOUT = 'LOGOUT';

// Register

export const REGISTRATION = 'REGISTRATION';

export const RESET_REGISTRATION = 'RESET_REGISTRATION';

export const CONFIRM_REGISTRATION = 'CONFIRM_REGISTRATION';

// ======== ERRORS ============
export const PROMISE_MIDDLEWARE_ERROR = 'PROMISE_MIDDLEWARE_ERROR';
export const DEQUEUE_ERROR = 'DEQUEUE_ERROR';
export const QUEUE_ERROR = 'QUEUE_ERROR';


// INTL
export const UPDATE_LOCALE = 'UPDATE_LOCALE';

//Breadcrumbs
export const CHANGE_BREADCRUMB = 'CHANGE_BREADCRUMB';


// ============== SETTINGS TAB =========== //

// General

export const FETCH_USER_GENERAL_INFO = 'FETCH_USER_GENERAL_INFO';

export const CHANGE_CURRENT_ORGANIZATION_INDEX =
  'CHANGE_CURRENT_ORGANIZATION_INDEX';


// Plant
export const CHANGE_CURRENT_PLANT_INDEX = 'CHANGE_CURRENT_PLANT_INDEX';

// Section
export const CHANGE_CURRENT_SECTION_INDEX = 'CHANGE_CURRENT_SECTION_INDEX';

// Devices

// Listing
export const DEVICES_FETCH_LISTING = 'DEVICES_FETCH_LISTING';

//scaled
export const DEVICES_FETCH_SCALED = 'DEVICES_FETCH_SCALED';

export const ADD_TURN_TO_STATE = 'ADD_TURN_TO_STATE';
export const DELETE_TURN_FROM_STATE = 'DELETE_TURN_FROM_STATE';
export const ADD_MONITORABLE_TO_STATE = 'ADD_MONITORABLE_TO_STATE';
export const UPDATE_MONITORABLE = 'UPDATE_MONITORABLE';
export const ADD_INDICATOR_TO_STATE = 'ADD_INDICATOR_TO_STATE';

export const UPDATE_CURRENT_PLANT = 'UPDATE_CURRENT_PLANT';



// WEBPACK FOOTER //
// ./constants/ActionTypes.js